'use client'

import React from 'react'
import { styled } from '@mui/material/styles'
import { Box, Typography, Link } from '@mui/material'
import { Content, Sticky, Header, Divider } from '@/components/ui'
import { config } from '@/config'
import { LegalInformation } from '@/components/legalInformation'

const PrimaryList = styled('ol')`
  padding-left: 18px;
`

const SecondaryList = styled('ol')`
  padding-left: 0;
  list-style-type: none;
`

const ListItem = styled('li')`
  & + & {
    margin-top: 24px;
  }
`

const ListItemValue = styled(Typography)`
  font-weight: normal;
`

const TermsOfService: React.FC = () => {
  return (
    <>
      <Sticky stickTo="top">
        <Header title="Terms of Service" />
      </Sticky>
      <Content sx={{ pb: 2, flexGrow: 1 }}>
        <Box sx={{ pb: 2 }}>
          <Divider light />
        </Box>
        <PrimaryList>
          <ListItem>
            <ListItemValue variant="body1">
              When you opt-in to the service, we will send you an SMS message to confirm your signup. You can cancel the
              SMS service at any time. Just text "STOP" to #####. After you send the SMS message "STOP" to us, we will
              send you an SMS message to confirm that you have been unsubscribed. After this, you will no longer receive
              SMS messages from us.
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              If you want to join again, just sign up as you did the first time and we will start sending SMS messages
              to you again.
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              If at any time you forget what keywords are supported, just text "HELP" to #####. After you send the SMS
              message "HELP" to us, we will respond with instructions on how to use our service as well as how to
              unsubscribe.
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              We are able to deliver messages to the following mobile phone carriers:
            </ListItemValue>
            <SecondaryList>
              <ListItem>
                <ListItemValue variant="body1">
                  Major carriers: AT&T, Verizon Wireless, Sprint, T-Mobile, U.S. Cellular, Alltel, Boost Mobile, Nextel,
                  and Virgin Mobile.
                </ListItemValue>
              </ListItem>
              <ListItem>
                <ListItemValue variant="body1">
                  Minor carriers: Alaska Communications Systems (ACS), Appalachian Wireless (EKN), Bluegrass Cellular,
                  Cellular One of East Central IL (ECIT), Cellular One of Northeast Pennsylvania, Cincinnati Bell
                  Wireless, Cricket, Coral Wireless (Mobi PCS), COX, Cross, Element Mobile (Flat Wireless), Epic Touch
                  (Elkhart Telephone), GCI, Golden State, Hawkeye (Chat Mobility), Hawkeye (NW Missouri), Illinois
                  Valley Cellular, Inland Cellular, iWireless (Iowa Wireless), Keystone Wireless (Immix Wireless/PC
                  Man), Mosaic (Consolidated or CTC Telecom), Nex-Tech Wireless, NTelos, Panhandle Communications,
                  Pioneer, Plateau (Texas RSA 3 Ltd), Revol, RINA, Simmetry (TMP Corporation), Thumb Cellular, Union
                  Wireless, United Wireless, Viaero Wireless, and West Central (WCC or 5 Star Wireless).
                </ListItemValue>
              </ListItem>
            </SecondaryList>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              As always, message and data rates may apply for any messages sent to you from us and to us from you. You
              will receive 2 message. If you have any questions about your text plan or data plan, it is best to contact
              your wireless provider.
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              For all questions about the services provided by this short code, you can send an email to{' '}
              <Link target="_blank" href={`mailto:${config.customerSupport.email}`}>
                {config.customerSupport.email}
              </Link>
              .
            </ListItemValue>
          </ListItem>
          <ListItem>
            <ListItemValue variant="body1">
              If you have any questions regarding privacy, please read our{' '}
              <Link target="_blank" href="/privacy-policy">
                privacy policy
              </Link>
              .
            </ListItemValue>
          </ListItem>
        </PrimaryList>
        <ListItemValue align="center">{<LegalInformation />}</ListItemValue>
      </Content>
    </>
  )
}

export default TermsOfService
